import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { useLanguage, getSuccessPageTranslation } from '../hooks/useLanguage';

const API_BASE_URL = process.env.REACT_APP_DOCS_API_KEY;

const Cancel = () => {
  const [isSpanish] = useLanguage();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = localStorage.getItem('stripeSessionId');
    if (!sessionId) {
      setLoading(false);
      return;
    }
    const deleteSession = async () => {
      try {
        const response = await fetch(`https://${API_BASE_URL}/api/payments/session/${sessionId}`, {
          method: 'DELETE',
        });
        if (!response.ok) {
          const data = await response.json();
          throw new Error(data.error || 'Failed to delete payment session');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        localStorage.removeItem('stripeSessionId');
        setLoading(false);
      }
    };
    deleteSession();
  }, [isSpanish]);

  return (
    <div className="flex justify-center items-center mt-20">
      <div className="bg-white border-container p-8 rounded-3xl max-w-1/2 text-center ">
        <div className="flex justify-center mb-4">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-red-500">
            <X className="w-10 h-10 stroke-white" />
          </span>
        </div>
        <h1 className="text-2xl font-bold mb-2 shine">
          {isSpanish ? 'Pago cancelado' : 'Payment Cancelled'}
        </h1>
        <p className="mb-4 text-gray-700">
          {isSpanish ? 'La transacción ha sido cancelada. No se ha realizado ningún cargo.' : 'The transaction was cancelled. No payment was made.'}
        </p>
        {/* {error && <div className="text-red-600 mb-2">{error}</div>} */}
        <a href="/" className="w-full inline-block mt-8 px-6 py-3 bg-default text-white rounded-full transition">
          {getSuccessPageTranslation('goToHome', isSpanish)}
        </a>
      </div>
    </div>
  );
};

export default Cancel; 